import './index.css';

const ConfigurationSection = ({ classname = '', children }) => {
  const firstChild = children.length ? children[0] : children;
  const secondChild = children.length ? children[1] : null;
  return (
    <div className={`configration-section ${classname}`}>
      {firstChild && (
        <div className="configration-section-left">{firstChild}</div>
      )}
      {secondChild && (
        <div className="configration-section-right">{secondChild}</div>
      )}
    </div>
  );
};

export default ConfigurationSection;
